import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import CompanyInterface, { companyInitialValue } from "@/types/app/companies";
import ErrorService from "./erroService";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import ResultResponseInterface, { resultResponseInitialValue } from "@/types/app/resultResponse";

export default class CompanyService {

  constructor(private api: AxiosInstance, private endpoint: Endpoint = new Endpoint()) { }

  async getCompanies(): Promise<CompanyInterface[]> {

    try {
      const { data } = await this.api.get<CompanyInterface[]>(`${this.endpoint.companies}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  async getCompanyById(companyId:string): Promise<CompanyInterface> {

    try {
      const { data } = await this.api.get<CompanyInterface>(`${this.endpoint.companies}/${companyId}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return companyInitialValue;
    }

  }

  async getCompanyItems(): Promise<VuetifySelectItems[]> {

    try {
      const { data } = await this.api.get<VuetifySelectItems[]>(`${this.endpoint.companies}/select-items`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  async deleteCompanies(companyIds: string[]): Promise<ResultResponseInterface> {
    try {
     const { data } = await this.api.delete(`${this.endpoint.companies}`, { data: { companyIds } });
      return data;
    } catch (error) {
      return ErrorService.onError(error);    
    }
  }

  async saveCompany(company: CompanyInterface): Promise<ResultResponseInterface> {
    try {
      const entity = { name: company.name, 
                      companyId: company.id?.length == 0 ? null : company.id,
                      email: company.email,
                      country: company.country };
      const response = await this.api.post(this.endpoint.companies, entity);
      console.log(response)
      return response as any;
    } catch (error) {
      return ErrorService.onError(error);
    }
  }

  async saveCompanyInfo(id:string, name:string, email:string, country:string): Promise<ResultResponseInterface> {
    try {
      const entity = { companyName: name, companyEmail: email, companyCountry: country};
      const { data } = await this.api.put(`${this.endpoint.companies}/${id}`, entity);
      return data;
    } catch (error) {
      return ErrorService.onError(error);      
    }
  }

  async saveCompanyManagers(id:string, managerIds:string[]): Promise<ResultResponseInterface> {
    try {
      const entity = { managerIds: managerIds};
      const data = await this.api.put(`${this.endpoint.companies}/${id}/save-managers`, entity);
      
      return data as any;
    } catch (error) {
      return ErrorService.onError(error);
    }
  }

  async importData(companies:any[]): Promise<ResultResponseInterface>{
    try {
      const entity = { companies };
      const data = await this.api.post(`${this.endpoint.companies}/import-data`, entity);
      return data as any;
    } catch (error) {
      return ErrorService.onError(error);      
    }
  }

  async saveCompanyInvestor(companyId:string, name:string, email:string, investorId:string): Promise<ResultResponseInterface> {
    try {
      const entity = { name: name, email: email, investorId: investorId};
      const data = await this.api.put(`${this.endpoint.companies}/${companyId}/save-investor`, entity);
      return data as any;

    } catch (error) {
      return ErrorService.onError(error);
    }
  }

  async saveCompanyInvestorClientUser(companyId:string, invetors:any[]): Promise<ResultResponseInterface> {
    try {
      const entity = { clients: invetors};
      const data = await this.api.put(`${this.endpoint.companies}/${companyId}/save-clients`, entity);
      return data as any;
    } catch (error) {
      return ErrorService.onError(error);      
    }
  }

  async deleteCompanyInvestor(companyId: string, investorId: string): Promise<ResultResponseInterface> {
    try {
      const data = await this.api.delete(`${this.endpoint.companies}/${companyId}/${investorId}`);
      return data as any;
    } catch (error) {
     return ErrorService.onError(error);      
    }
  }

  async deleteCompanyManager(companyId: string, userId: string): Promise<ResultResponseInterface> {
    try {
      const data = await this.api.delete(`${this.endpoint.companies}/${companyId}/manager/${userId}`);
      return data  as any;
    } catch (error) {
      return ErrorService.onError(error);     
    }
  }

}